module.exports = __webpack_public_path__ + "img/tutorial3.a65d89c6.png";